import React, {useState} from 'react';
import styled from 'styled-components';
import {CheckBox} from "../../../components/common/CheckBox";

const SortArea = (props) => {
    const [st, setSt] = useState(true)
return(
  <Container>
    <Sort>
        <Title>
            <p>Type</p>
        </Title>
        <CheckList>
            <CheckItem
                onClick={()=>{
                    if(props?.data?.isVideo == false) {
                        props?.onChange("isVideo", !props?.data?.isVideo)
                    }
                    props?.onChange("isClassic", !props?.data?.isClassic)
                }}
            >
                <CheckBox onClick={()=>{}}
                          state={props?.data?.isClassic}
                />
                <span>
                    Classic
                </span>
            </CheckItem>
            <CheckItem
                onClick={()=>{
                    props?.onChange("isVideo", !props?.data?.isVideo)
                }}
            >
                <CheckBox onClick={()=>{}}
                          state={props?.data?.isVideo}
                />
                <span>
                    Video
                </span>
            </CheckItem>
        </CheckList>
    </Sort>
    <Sort>
          <Title
            style={{minWidth:150}}
          >
              <p>Delivery Speed</p>
          </Title>
          <CheckList>
              <CheckItem
                  onClick={()=>{
                      props?.onChange("is24hr", !props?.data?.is24hr)
                  }}
              >
                  <CheckBox onClick={()=>{}}
                            state={props?.data?.is24hr}
                  />
                  <span>
                    24 hrs
                </span>
              </CheckItem>
              <CheckItem
                  onClick={()=>{
                      setSt(v => !v)
                  }}
              >
                  <CheckBox onClick={()=>{}}
                            state={st}
                  />
                  <span>
                    Standard
                </span>
              </CheckItem>
          </CheckList>
      </Sort>
  </Container>
)

}
export default SortArea;

const Container = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    padding: 20px 5%;
    justify-content: space-between;
    border-radius: 10px;
    border: 0.6px solid rgba(51, 51, 51, 0.60);
    background: #FFF;
    box-shadow: 0px 0px 6px 0px rgba(51, 51, 51, 0.16);
    margin-bottom: 1.25rem;
    flex-wrap: wrap;
`;
const Sort = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`
const Title = styled.div`
    min-width: 100px;
    p{
        color: #333;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%;
    }
`
const CheckList = styled.div`
   display: flex;align-items: center;
    flex-wrap: wrap;
`
const CheckItem = styled.div`
   display: flex;
    align-items: center;
    width: 104px;
    cursor: pointer;
    span{
        margin-left: 8px;
        display: flex;
        width: 80px;
        font-family: "Europa-Bold";
        flex-direction: column;
        justify-content: center;
        flex-shrink: 0;
        color: #333;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
    }
    .on {
        transition: all 0.2s;

        & > div {
            transition: all 0.2s;
            border: solid 1px #333!important;
            background: #333!important;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
`